import React from 'react';
import styles from './StudyCard.scss';
import moment from 'moment';
import { UserCanManageStudyMonitorsOld } from 'common/permissions/components/actionButton';
import { Button, BUTTON } from 'components/common/Button/Button';

const { SIZE, COLOR, BGCOLOR } = BUTTON;

export function Monitors({ studyMonitors, isEditable, onEdit, onClear, setSelectedUser, setShowModal }) {

    const editMonitor = monitor => {
        onEdit(monitor);
    };

    const clearUser = (monitor) => {
        if (onClear) {
            onClear(monitor);
        } else {
            setSelectedUser(monitor);
            setShowModal(true);
        }
    };

    const monitorCards = studyMonitors.map(monitor => {
        return (
            <li
                key={monitor.id}
                className={styles.monitorCard}
                data-cy={'Monitors' + monitor.id}
            >
                <Monitor
                    displayName={monitor.displayName}
                    emailAddress={monitor.emailAddress}
                />
                <MonitorDates
                    startDate={monitor.startDate}
                    endDate={monitor.endDate}
                />
                <MonitorControls
                    editMonitor={editMonitor}
                    isEditable={isEditable}
                    monitor={monitor}
                    onClear={clearUser}
                />
            </li>
        );
    });

    return <ul className={styles.monitorCards} data-cy="monitorCards" >{monitorCards}</ul>;
}

export function Monitor({ displayName, emailAddress }) {
    return (
        <div
            className={styles.monitorDetails}
        >
            <h1>{displayName}</h1>
            <h2>{emailAddress}</h2>
        </div >
    );
}

export function MonitorDates({ startDate, endDate }) {
    return (
        <div
            className={styles.monitorDates}
        >
            <h1>{'Study Access'}</h1>
            <p className={styles.memberCardRole}>
                {`${moment(startDate).format('MMMM D, YYYY')} - ${formatEndDate(endDate)}`}
            </p>
        </div >
    );
}

export function MonitorControls({ editMonitor, isEditable, monitor, onClear }) {

    const EditDetailsButton = () => (
        <Button
            className={styles.memberCardEdit}
            text={'Edit Details'}
            type={SIZE.PRIMARY}
            color={COLOR.BLUE}
            bgcolor={BGCOLOR.CLEAR}
            onClick={() => editMonitor(monitor)}
        />
    );

    const RemoveButton = () => (
        <i
            className={styles.memberCardDelete}
            onClick={() => onClear(monitor)}
        >
            {'close'}
        </i>
    );

    const SecuredEditDetailsButton = UserCanManageStudyMonitorsOld(EditDetailsButton) ;
    const SecuredRemoveButton = UserCanManageStudyMonitorsOld(RemoveButton);

    return (
        <div className={styles.monitorControls}>
            {isEditable && <SecuredEditDetailsButton />}
            <SecuredRemoveButton />
        </div>
    );
}

const formatEndDate = endDate => {
    if (!endDate) {
        return 'Indefinite';
    }

    return moment(endDate).format('MMMM D, YYYY');
};
